(() => {
  const SELECTOR = '[data-discover-content]';

  const initialise = (root) => {
    if (!root || root.dataset.discoverEnhanced === 'true') return;

    const track = root.querySelector('[data-discover-track]');
    const previous = root.querySelector('[data-discover-prev]');
    const next = root.querySelector('[data-discover-next]');
    if (!track || !previous || !next) return;

    root.dataset.discoverEnhanced = 'true';

    const cards = () => Array.from(track.children).filter((item) => item instanceof HTMLElement);
    const isRtl = () => window.getComputedStyle(track).direction === 'rtl';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateControls = () => {
      const items = cards();
      if (!items.length) {
        previous.disabled = true;
        next.disabled = true;
        return;
      }

      const trackRect = track.getBoundingClientRect();
      const firstRect = items[0].getBoundingClientRect();
      const lastRect = items[items.length - 1].getBoundingClientRect();
      const tolerance = 3;

      const atStart = isRtl()
        ? firstRect.right <= trackRect.right + tolerance && firstRect.right >= trackRect.right - tolerance
        : firstRect.left >= trackRect.left - tolerance;
      const atEnd = isRtl()
        ? lastRect.left >= trackRect.left - tolerance
        : lastRect.right <= trackRect.right + tolerance;

      previous.disabled = atStart;
      next.disabled = atEnd;
      previous.setAttribute('aria-disabled', String(atStart));
      next.setAttribute('aria-disabled', String(atEnd));
    };

    const scrollOnePage = (direction) => {
      const firstCard = cards()[0];
      if (!firstCard) return;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const amount = firstCard.getBoundingClientRect().width + gap;
      const writingDirection = isRtl() ? -1 : 1;

      track.scrollBy({
        left: amount * direction * writingDirection,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    previous.addEventListener('click', () => scrollOnePage(-1));
    next.addEventListener('click', () => scrollOnePage(1));

    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();

      const direction = event.key === 'ArrowRight' ? 1 : -1;
      scrollOnePage(isRtl() ? direction * -1 : direction);
    });

    let scrollFrame;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      },
      { passive: true },
    );

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateControls, { passive: true });
    }

    updateControls();
  };

  const initialiseWithin = (scope = document) => {
    if (scope.matches?.(SELECTOR)) initialise(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseWithin(), { once: true });
  } else {
    initialiseWithin();
  }

  if (!window.__discoverContentSectionListener) {
    window.__discoverContentSectionListener = true;
    document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
  }
})();
